import { BaseEntity } from './BaseEntity';

export class ProgrammeCertify implements BaseEntity {
  programmeId?: string;

  comment?: string;
}
